import classNames from 'classnames';
import React from 'react';
import { ScrollableBody } from '../../components/Layout/ScrollableBody/ScrollableBody';
import { CTAButton } from '../ButtonBase/index';
import { useLocalization } from '../../context/Localization/localization';
import { RoundedText } from '../RoundedText/RoundedText';
import css from './OptionBoxes.module.scss';

export interface IProps {
    primaryText: string | JSX.Element;
    primaryButtonText: string;
    primaryButtonTitle?: string;
    onPrimaryClick: () => void;
    secondaryText: string | JSX.Element;
    secondaryButtonText: string;
    secondaryButtonTitle?: string;
    onSecondaryClick: () => void;
}

export const OptionBoxes: React.FC<IProps> = React.memo((props) => {
    const Localization = useLocalization();

    return (
        <ScrollableBody>
            <div className={css.optionBoxes}>
                <div className={css.growBox}>
                    <div className={classNames(css.box, css.primary, typeof props.primaryText === 'string' ? css.text : '')}>
                        {React.isValidElement(props.primaryText) ? <>{props.primaryText}</> : <span>{props.primaryText}</span>}
                    </div>
                    <div className={classNames(css.box)}>
                        <CTAButton
                            styleType={'primary'}
                            onClick={() => {
                                props.onPrimaryClick();
                            }}
                            title={props.primaryButtonTitle}
                            label={props.primaryButtonText}
                            id={props.primaryButtonTitle ?? props.primaryButtonText}
                            ariaLabel={props.primaryButtonTitle ?? props.primaryButtonText}
                        />
                    </div>
                </div>
                <div>
                    <div className={classNames(css.box)}>
                        <RoundedText
                            text={Localization.Or}
                            ariaLabel={Localization.Or}
                            styleType={'secondary'}
                            size={'large'}
                        />
                    </div>
                </div>
                <div className={css.growBox}>
                    <div className={classNames(css.box, css.secondary, typeof props.secondaryText === 'string' ? css.text : '')}>
                        {React.isValidElement(props.secondaryText) ? <>{props.secondaryText}</> : <span>{props.secondaryText}</span>}
                    </div>
                    <div className={classNames(css.box)}>
                        <CTAButton
                            styleType={'secondary'}
                            onClick={() => {
                                props.onSecondaryClick();
                            }}
                            title={props.secondaryButtonTitle}
                            label={props.secondaryButtonText}
                            id={props.secondaryButtonTitle ?? props.secondaryButtonText}
                            ariaLabel={props.secondaryButtonTitle ?? props.secondaryButtonText}
                        />
                    </div>
                </div>
            </div>
        </ScrollableBody>
    );
});

export { OptionBoxes as default };
